/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Entity_Sales_InvoicesInputs */



/**
* | output |
* | --- |
* | "Sales invoices" |
*
* @param {Agent_Event_Entity_Sales_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_entity_sales_invoices = /** @type {((inputs?: Agent_Event_Entity_Sales_InvoicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Entity_Sales_InvoicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verkaufsrechnungen")
	return /** @type {LocalizedString} */ ("Sales invoices")
});